import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Image, Form, Button, ListGroup } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../../components/Card";
import animationData from "../../../assets/LottieFolder/LoginJson.json";
import { Eye, EyeOff } from "lucide-react";
import Lottie from "react-lottie";
// img
import facebook from "../../../assets/images/brands/fb.svg";
import google from "../../../assets/images/brands/gm.svg";
import instagram from "../../../assets/images/brands/im.svg";
import linkedin from "../../../assets/images/brands/li.svg";
import auth1 from "../../../assets/images/auth/01.png";
import {
  login,
  signUp,
  verifyOtp,
  resendOtp,
} from "../../../services/authentication";
import "../../../assets/css/auth.css";
import { CSSTransition } from "react-transition-group";
import {
  callToast,
  checkIfCodeExistsInFailures,
  showErrorMessages,
} from "../../../services/utilityFunctions.js";
const Auth = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const [currentView, setCurrentView] = useState("login");
  const [otpTimer, setOtpTimer] = useState(30);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    otp: "",
  });

  // OTP Timer
  useEffect(() => {
    let interval;
    if (currentView === "verify" && otpTimer > 0) {
      interval = setInterval(() => {
        setOtpTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [currentView, otpTimer]);

  const handleResendOTP = () => {
    setOtpTimer(30);
    // Add resend OTP logic here
  };

  const [error, setError] = useState({ error: false, message: "" });

  return (
    <section className="login-content">
      <Row className="m-0 align-items-center bg-white vh-100">
        <Col
          md="6"
          className="d-md-block d-none p-0 mt-n1 vh-100 overflow-hidden "
        >
          <Lottie
            options={defaultOptions}
            height={"100%"}
            width={"100%"}
            className="animated-scaleX"
          />
        </Col>

        <Col
          md="6"
          className=" d-md-block d-none p-0 mt-n1 vh-100 overflow-hidden"
        >
          <Row className="pt-5  justify-content-center me-3 ms-3">
            <Row md="2" lg="2" style={{ height: "70" }}>
              {error.error ? (
                <CSSTransition
                  in={error.error}
                  timeout={300}
                  classNames="error-animation"
                  unmountOnExit
                  onEntered={(node) => {
                    node.classList.add("auth-error");

                    setTimeout(() => {
                      node.classList.remove("auth-error");
                      void node.offsetWidth; // Trigger reflow
                      node.classList.add("auth-error");
                    }, 0);
                  }}
                >
                  <div className="auth-error alert alert-danger border-0 rounded-lg shadow position-relative overflow-hidden">
                    <div className="d-flex align-items-center">
                      <div className="error-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          className="text-danger"
                        >
                          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                          <line x1="12" y1="9" x2="12" y2="13"></line>
                          <line x1="12" y1="17" x2="12" y2="17"></line>
                        </svg>
                      </div>
                      <div>
                        <h6 className="mb-1 text-danger">
                          Oops! Something went wrong
                        </h6>
                        <p className="small mb-0">{error.message}</p>
                      </div>
                      <button
                        type="button"
                        className="btn-close ms-auto"
                        onClick={() => setError({ error: false, message: "" })}
                      />
                    </div>
                  </div>
                </CSSTransition>
              ) : (
                <div style={{ height: "70px" }} />
              )}
            </Row>
            <Row md="11 m-5 mt-0 p-5 pt-0">
              <Card
                className="card-transparent auth-card "
                style={{
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
                  borderRadius: "16px",
                  transition: "box-shadow 0.3s ease",
                  border: "1px solid rgba(0, 0, 0, 0.06)",
                }}
              >
                <Card.Body>
                  <div className="transition-wrapper">
                    <CSSTransition
                      in={currentView === "login"}
                      timeout={500}
                      classNames="slide"
                      unmountOnExit
                    >
                      <div>
                        <LoginForm
                          onSignup={() => setCurrentView("signup")}
                          error={error}
                          setError={setError}
                        />
                      </div>
                    </CSSTransition>

                    <CSSTransition
                      in={currentView === "signup"}
                      timeout={500}
                      classNames="slide"
                      unmountOnExit
                    >
                      <div>
                        <SignUpForm
                          formData={formData}
                          setError={setError}
                          setFormData={setFormData}
                          setCurrentView={setCurrentView}
                          onBack={() => setCurrentView("login")}
                        />
                      </div>
                    </CSSTransition>

                    <CSSTransition
                      in={currentView === "verify"}
                      timeout={500}
                      classNames="slide"
                      unmountOnExit
                    >
                      <div>
                        <VerifyOTP
                          formData={formData}
                          setError={setError}
                          setFormData={setFormData}
                          timer={otpTimer}
                          setOtpTimer={setOtpTimer}
                          setCurrentView={setCurrentView}
                          onResend={handleResendOTP}
                          onBack={() => setCurrentView("signup")}
                          // error={error}
                          // setError={setError}
                        />
                      </div>
                    </CSSTransition>
                  </div>
                </Card.Body>
              </Card>
            </Row>
          </Row>
        </Col>
      </Row>
    </section>
  );
};

const SignUpForm = ({
  formData,
  setFormData,
  setCurrentView,
  setError,
  onBack,
  error,
} = {}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formError, setFormError] = useState({});
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    signUp(formData)
      .then((res) => {
        if (res.status === "success") {
          setCurrentView("verify");
        } else if (checkIfCodeExistsInFailures(res, "OU012")) {
          // If the error code exists, try resending the OTP
          return resendOtp(formData).then((res2) => {
            if (res2.status === "success") {
              setError({ error: false, message: "" });
              setCurrentView("verify");
            } else {
              setError({ error: true, message: res2.message });
            }
          });
        } else {
          setError({ error: true, message: res.message });
          showErrorMessages({ data: res, navigate });
        }
      })
      .catch((error) => {
        setError({
          error: true,
          message: "Something went wrong. Please try again.",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const validateForm = () => {
    let isValid = true;

    Object.entries(formData).forEach(([key, value]) => {
      if (key === "otp") return; // Skip OTP validation

      if (!value || value.trim() === "") {
        isValid = false;
        setFormError((prev) => ({
          ...prev,
          [key]: "This field is required",
        }));
      } else {
        setFormError((prev) => ({
          ...prev,
          [key]: null,
        }));
      }
    });

    return isValid;
  };

  return (
    <div className="auth-form">
      <h2 className="mb-3 text-center">Create Account</h2>
      <p className="text-center mb-4">Join our community today!</p>

      {/* Error Section */}
      {error && <div className="auth-error alert alert-danger">{error}</div>}

      <Form>
        <Row>
          <Col md="6" className="mb-3">
            <Form.Group className="mb-1 ">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                required
                value={formData.firstName}
                onChange={(e) => {
                  setFormData({ ...formData, firstName: e.target.value });
                  setFormError((prev) => ({
                    ...prev,
                    firstName: null,
                  }));
                }}
              />
            </Form.Group>
            {formError.firstName && (
              <small className="text-danger ">{formError.firstName}</small>
            )}
          </Col>
          <Col md="6" className="mb-3">
            <Form.Group className="mb-1">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                required
                value={formData.lastName}
                onChange={(e) => {
                  setFormData({ ...formData, lastName: e.target.value });

                  setFormError((prev) => ({
                    ...prev,
                    lastName: null,
                  }));
                }}
              />
            </Form.Group>
            {formError.lastName && (
              <small className="text-danger ">{formError.lastName}</small>
            )}
          </Col>
        </Row>

        <div className="mb-3">
          <Form.Group className="mb-1">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              required
              value={formData.email}
              onChange={(e) => {
                setFormData({ ...formData, email: e.target.value });
                setFormError((prev) => ({
                  ...prev,
                  email: null,
                }));
              }}
            />
          </Form.Group>
          {formError.email && (
            <small className="text-danger ">{formError.email}</small>
          )}
        </div>

        <div className={formError.password ? "mb-2" : "mb-4"}>
          <Form.Group className="mb-1 position-relative">
            <Form.Label>Password</Form.Label>
            <div className="position-relative">
              <Form.Control
                type={showPassword ? "text" : "password"}
                required
                value={formData.password}
                onChange={(e) => {
                  setFormData({ ...formData, password: e.target.value });
                  setFormError((prev) => ({
                    ...prev,
                    password: null,
                  }));
                }}
                className="pe-5" // Add padding to make room for the icon
              />
              <button
                type="button"
                className="btn btn-link position-absolute end-0 top-50 translate-middle-y"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  border: "none",
                  background: "none",
                  padding: "0.375rem 0.75rem",
                  cursor: "pointer",
                }}
              >
                {!showPassword ? (
                  <EyeOff size={18} className="text-muted" />
                ) : (
                  <Eye size={18} className="text-muted" />
                )}
              </button>
            </div>
          </Form.Group>
          {formError.password && (
            <small className="text-danger ">{formError.password}</small>
          )}
        </div>

        <div className="d-flex justify-content-between">
          <Button
            variant="outline-secondary"
            onClick={onBack}
            disabled={loading}
          >
            Back
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <div>
                <div
                  class="spinner-border spinner-border-sm text-light me-2"
                  role="status"
                >
           
                </div>
                Continue
              </div>
            ) : (
              "Continue"
            )}
          </Button>
        </div>
      </Form>
    </div>
  );
};

const VerifyOTP = ({
  formData,
  setFormData,
  timer,
  onBack,
  setError,
  setOtpTimer,
  setCurrentView,
}) => {
  const otpRefs = useRef([]);
  var navigate = useNavigate();
  const handleInputChange = (e, index) => {
    const { value } = e.target;
    // Allow only alphanumeric characters
    const char = value.match(/^[a-zA-Z0-9]$/) ? value : "";
    // Create an array for OTP digits (default empty if not set)
    let otpArray = formData.otp ? formData.otp.split("") : Array(6).fill("");
    otpArray[index] = char;
    setFormData({ ...formData, otp: otpArray.join("") });

    // Move focus to next input if a valid character is entered
    if (char && index < 5) {
      otpRefs.current[index + 1].focus();
    }
  };
  const [loading, setLoading] = useState(false);
  const [otpSentLoading, setOtpSentLoading] = useState(false);
  const [fieldError, setFieldError] = useState(null);
  const onResend = async () => {
    setOtpSentLoading(true);

    var res = await resendOtp(formData);
    if (res.status === "success") {
      setOtpTimer(30);
      setOtpSentLoading(false);
      setFormData({ ...formData, otp: "" });
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setOtpSentLoading(false);
  };
  const onVerify = async (params) => {
    if (!formData.otp || formData.otp.length != 6) {
      setFieldError("Please enter a valid OTP");
      return;
    }
    setLoading(true);
    var res = await verifyOtp({
      identity: formData.email,
      authCode: formData.otp,
      type: "EMAIL",
    });

    console.log(res, "otp");
    console.log("data sent otp", {
      identity: formData.email,
      authCode: formData.otp,
      type: "EMAIL",
    });
    if (res.status === "success") {
      callToast(
        "success",
        "SUCCESS",
        "OTP verified successfully. please login to continue"
      );
      setCurrentView("login");
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoading(false);
  };
  const handlePaste = (e) => {
    e.preventDefault();
    // Get the pasted data and filter out non-alphanumeric characters
    const pasteData = e.clipboardData
      .getData("Text")
      .replace(/[^a-zA-Z0-9]/g, "")
      .slice(0, 6);
    const otpArray = pasteData.split("");
    setFormData({ ...formData, otp: otpArray.join("") });

    // Set the value for each input field
    otpArray.forEach((char, i) => {
      if (otpRefs.current[i]) {
        otpRefs.current[i].value = char;
      }
    });
    // Focus the next empty field if available
    if (otpRefs.current[otpArray.length]) {
      otpRefs.current[otpArray.length].focus();
    }
  };

  return (
    <div className="auth-form d-flex flex-column align-items-center">
      <h2 className="mb-3 text-center">Verify OTP</h2>
      <p className="text-center mb-4">
        We've sent a 6-digit code to <br />
        <strong>{formData.email}</strong>
      </p>

      <Form className="w-100" style={{ maxWidth: "400px" }}>
        <Form.Group className="mb-4 text-center">
          <Form.Label>Enter OTP</Form.Label>
          <div className="d-flex justify-content-center gap-2">
            {[...Array(6)].map((_, i) => (
              <Form.Control
                key={i}
                type="text"
                maxLength="1"
                className="text-center otp-input p-0"
                ref={(el) => (otpRefs.current[i] = el)}
                onChange={(e) => {
                  handleInputChange(e, i);

                  setFieldError(null);
                }}
                onPaste={handlePaste}
                style={{ width: "50px", height: "50px", fontSize: "1.5rem" }}
              />
            ))}
          </div>
        </Form.Group>
        {fieldError && (
          <small className="text-danger d-block text-center mb-3">
            {fieldError}
          </small>
        )}

        <div className="d-flex justify-content-center align-items-center mb-4 mt-3">
          {/* <Button variant="outline-secondary" onClick={onBack}>
            Back
          </Button> */}
          <Button variant="primary" onClick={onVerify} disabled={loading}>
            {loading ? (
              <>
                <div class="spinner-border spinner-border-sm" role="status">
           
                </div>{" "}
                Verify
              </>
            ) : (
              "Verify"
            )}
          </Button>
        </div>

        <div className="text-center">
          {timer > 0 ? (
            <span className="text-muted">
              Resend available in {timer} seconds
            </span>
          ) : (
            <Button
              variant="link"
              onClick={onResend}
              disabled={otpSentLoading}
              className="text-decoration-none"
            >
              {otpSentLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Sending...
                </>
              ) : (
                "Didn't receive the code? Resend"
              )}
            </Button>
          )}
        </div>
      </Form>
    </div>
  );
};

// Add CSS transitions

const  LoginForm = ({ onSignup, error, setError }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent page reload
    loginFunction(formData.username.trim(), formData.password.trim());
    // Add further logic (e.g., send to API)
  };
  function identifyUser(input) {
    // A basic regex pattern to validate email addresses
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailRegex.test(input) ? "EMAIL" : "USERNAME";
  }

  const loginFunction = async (username, password) => {
    setLoading(true);

    var data = {
      identity: username,
      password: password,
      type: identifyUser(username),
    };
    let res = await login(data);
    console.log(res);
    if (res.status === "success") {
      setLoading(false);
      if (res.data["USER TYPE"] === "WEB-USER") {
        navigate("/organisation/sites", { replace: true });
      } else if (res.data["USER TYPE"] === "ONBOARDING") {
        navigate("/onBoarding", { replace: true });
      }
    } else {
      setLoading(false);
      showErrorMessages({ data: res, navigate });
      // alert("Login failed");
    }
  };

  return (
    <>
      <div>
        <h2 className="mb-2 text-center">Login</h2>
        <p className="text-center">Login to stay connected.</p>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col lg="12">
              <Form.Group className="form-group">
                <Form.Label md="6" htmlFor="validationDefault01">
                  Username/Email
                </Form.Label>
                <Form.Control
                  type="text"
                  name="username"
                  id="validationDefault01"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col lg="12" className="">
              <Form.Group className="form-group">
                <Form.Label md="6" htmlFor="validationDefault02">
                  Password
                </Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  id="validationDefault02"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col lg="12" className="d-flex justify-content-between">
              <Form.Check className="form-check mb-3">
                <Form.Check.Input type="checkbox" id="customCheck1" />
                <Form.Check.Label htmlFor="customCheck1">
                  Remember Me
                </Form.Check.Label>
              </Form.Check>
              <Link to="/auth/recoverpw">Forgot Password?</Link>
            </Col>
          </Row>
          <div className="d-flex justify-content-center">
            <Button type="submit" variant="btn btn-primary" disabled={loading}>
              {loading ? (
                <div class="spinner-border spinner-border-sm" role="status">
           
                </div>
              ) : null}{" "}
              Sign In
            </Button>
          </div>
          <p className="text-center my-3">or sign in with other accounts?</p>
          <div className="d-flex justify-content-center">
            <ListGroup
              as="ul"
              className="list-group-horizontal list-group-flush"
            >
              <ListGroup.Item as="li" className="border-0 pb-0">
                <Link to="#">
                  <Image src={facebook} alt="fb" />
                </Link>
              </ListGroup.Item>
              <ListGroup.Item as="li" className="border-0 pb-0">
                <Link to="#">
                  <Image src={google} alt="gm" />
                </Link>
              </ListGroup.Item>
              <ListGroup.Item as="li" className="border-0 pb-0">
                <Link to="#">
                  <Image src={instagram} alt="im" />
                </Link>
              </ListGroup.Item>
              <ListGroup.Item as="li" className="border-0 pb-0">
                <Link to="#">
                  <Image src={linkedin} alt="li" />
                </Link>
              </ListGroup.Item>
            </ListGroup>
          </div>
          <p className="mt-3 text-center">
            Don't have an account?{" "}
            <span
              onClick={onSignup}
              className="text-primary cursor-pointer"
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                transition: "color 0.2s ease",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#0a58ca")}
              onMouseLeave={(e) => (e.target.style.color = "#0d6efd")}
            >
              Click here to sign up
            </span>
          </p>
        </Form>
      </div>
    </>
  );
};

export default Auth;
